// T-202 — export CSV des prospects sélectionnés (côté navigateur : aucune donnée ne passe par un tiers) et utilitaires purs de la grille Prospects.

export const COLONNES_EXPORT = [
  ["beneficiaire", "Bénéficiaire"], ["siret", "SIRET"], ["site", "Site"], ["cp", "CP"], ["ville", "Ville"],
  ["operation", "Opération"], ["commercial", "Commercial"], ["source", "Source"], ["statut_libelle", "Statut"], ["created_at", "Reçu le"],
];

/** Une cellule CSV : guillemets doublés ; une valeur qui commencerait par = + - @ est neutralisée (injection de formule dans un tableur). */
export function cellule(v) {
  let s = v == null ? "" : String(v);
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return `"${s.replace(/"/g, '""')}"`;
}

/** CSV (séparateur « ; » pour un tableur français, BOM UTF-8) des lignes de grille données. */
export function construireCsv(lignes) {
  const entete = COLONNES_EXPORT.map(([, l]) => cellule(l)).join(";");
  const corps = (lignes || []).map((r) => COLONNES_EXPORT.map(([k]) => cellule(r[k])).join(";"));
  return "﻿" + [entete, ...corps].join("\r\n");
}

export function telechargerCsv(lignes, nom = "prospects.csv") {
  const blob = new Blob([construireCsv(lignes)], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = nom; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Options du filtre « commercial » : ceux qui apparaissent dans les lignes + « Sans commercial ». */
export function optionsCommerciaux(lignes) {
  const vus = new Map();
  for (const r of lignes || []) if (r.commercial_id) vus.set(r.commercial_id, r.commercial);
  const opts = [...vus.entries()].map(([id, nom]) => ({ value: nom, label: nom, id })).sort((a, b) => a.label.localeCompare(b.label, "fr"));
  return [{ value: "—", label: "Sans commercial" }, ...opts];
}

/** Résumé lisible d'un rapport de lot (`summary` du serveur). */
export function resumeLot(summary = {}) {
  const lib = { attribue: "attribué(s)", attribution_retiree: "attribution(s) retirée(s)", archive: "archivé(s)", desarchive: "désarchivé(s)", refuse: "refusé(s) (transmis ou converti)", introuvable: "introuvable(s)" };
  return Object.entries(summary).map(([k, n]) => `${n} ${lib[k] || k}`).join(" · ") || "Aucun changement";
}
